// extracted by mini-css-extract-plugin
export var appButton = "Llij4";
export var appButtonIcon = "rxLNL";
export var buttonText = "EHbZZ";
export var documentButton = "ysM1C";
export var documentButtonIcon = "c869b";
export var loading = "Dx2BS";
export var moduleContainer = "EZxny";
export var separator = "yMjPT";